import { render, staticRenderFns } from "./DirectRecordStage.vue?vue&type=template&id=348405d9&scoped=true"
import script from "./DirectRecordStage.vue?vue&type=script&lang=ts"
export * from "./DirectRecordStage.vue?vue&type=script&lang=ts"
import style0 from "./DirectRecordStage.vue?vue&type=style&index=0&id=348405d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348405d9",
  null
  
)

export default component.exports